import { Outlet, useLocation } from "react-router-dom";
import { cn } from "@fmc-digital/ui";
import { ROUTES } from "@/constants/routes.constants";
import { Footer } from "@/components/organisms/Footer";
import { Header } from "@/components/organisms/Header";

/** Forgot flows: top-align form in `<main>` while keeping main flex-grow so footer stays at viewport bottom. */
const FORGOT_FLOW_ROUTES = new Set<string>([ROUTES.FORGOT_PASSWORD, ROUTES.FORGOT_EMAIL]);

const TOP_ALIGNED_AUTH_ROUTES = new Set<string>([
  ROUTES.FORGOT_PASSWORD,
  ROUTES.FORGOT_EMAIL,
  ROUTES.REGISTER,
  ROUTES.REGISTER_CREATE_ACCOUNT,
  ROUTES.REGISTER_SUCCESS,
  ROUTES.REGISTER_FEEDBACK,
  ROUTES.DOWNLOAD_APP,
]);

/**
 * Auth Layout
 * Provides consistent layout for all auth pages
 */
export function AuthLayout() {
  const { pathname } = useLocation();
  const isForgotFlow = FORGOT_FLOW_ROUTES.has(pathname);
  const isTopAligned = TOP_ALIGNED_AUTH_ROUTES.has(pathname);

  return (
    <div className="auth-layout">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main
        className={cn(
          "auth-container",
          (isForgotFlow || isTopAligned) && "auth-container-forgot-flow",
        )}
      >
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

